<div [ngClass]="{'loader_transparent': transparent, loader_size_small: sizeSmall}" class="loader">
  <!--<div class="loader__content">-->
    <!--<div class="loader__text"><ng-content></ng-content></div>-->
    <div class="loader__loader">
      <span class="loader__item"></span>
      <span class="loader__item"></span>
      <span class="loader__item"></span>
      <span class="loader__item"></span>
      <span class="loader__item"></span>
      <span class="loader__item"></span>
      <span class="loader__item"></span>
      <span class="loader__item"></span>
      <span class="loader__item"></span>
      <span class="loader__item"></span>
      <div class="loader__label" *ngIf="label">{{label}}</div>
      <div class="loader__info" *ngIf="info">{{info}}</div>
    </div>
  <!--</div>-->

</div>
